import { Pipe, PipeTransform } from '@angular/core';
import { ColumnType } from '@datachain/ui-sdk/components/dc-types';

import { CharacteristicType } from '../../core/dc-core-types';
import { HEADER_TYPES_COMPATIBILITY_MATRIX } from '../../core/utils/common-mappings';

@Pipe({
	name: 'toCompatibleTypeMapping',
})
export class ToCompatibleTypeMappingPipe implements PipeTransform {
	private static readonly cache = new Map<
		ColumnType,
		Array<CharacteristicType>
	>();

	public transform(value: ColumnType): Array<CharacteristicType> {
		if (ToCompatibleTypeMappingPipe.cache.has(value)) {
			return ToCompatibleTypeMappingPipe.cache.get(
				value
			) as Array<CharacteristicType>;
		}
		const canBeMapped = HEADER_TYPES_COMPATIBILITY_MATRIX.has(value);
		if (canBeMapped) {
			const correspondingMappings = HEADER_TYPES_COMPATIBILITY_MATRIX.get(
				value
			) as Array<ColumnType>;
			const mappings = correspondingMappings.map((m, idx) => ({
				id: idx,
				value: m,
				label: this.getLabel(m),
			}));
			ToCompatibleTypeMappingPipe.cache.set(value, mappings);
			return mappings;
		}
		const mapping = [
			{
				id: 0,
				value,
				label: this.getLabel(value),
			},
		];
		ToCompatibleTypeMappingPipe.cache.set(value, mapping);
		return mapping;
	}

	private getLabel(type: ColumnType): string {
		switch (type) {
			case ColumnType.Str:
				return $localize`:i18n=@@general.type.string:`;
			case ColumnType.Int:
				return $localize`:i18n=@@general.type.integer:`;
			case ColumnType.Double:
			case ColumnType.BigInt:
				return $localize`:i18n=@@general.type.bigInt:`;
			case ColumnType.Dec:
				return $localize`:i18n=@@general.type.decimal:`;
			case ColumnType.Date:
				return $localize`:i18n=@@general.type.dateTimestamp:`;
			case ColumnType.Words:
				return $localize`:i18n=@@general.type.words:`;
			case ColumnType.File:
				return $localize`:i18n=@@general.type.file:`;
			case ColumnType.Bool:
				return $localize`:i18n=@@general.type.boolean:`;
			case ColumnType.Geo:
				return $localize`:i18n=@@general.type.geometry:`;
			case ColumnType.Bin:
				return $localize`:i18n=@@general.type.binary:`;
			default:
				return 'UNMAPPED TYPE';
		}
	}
}
